export default "__VITE_ASSET__D3l6AHkH__"